import React from 'react';

interface Props {
  onClick: () => void;
  disabled?: boolean;
  className?: string;
  color?: 'neutral' | 'primary' | 'secondary' | 'success' | 'warn' | 'danger';
  type?: 'button' | 'submit' | 'reset';
}

const colors = {
  'neutral': 'border-primary-400 hover:bg-primary-400 active:bg-primary-700',
  'primary': 'border-primary-400 hover:bg-primary-400 active:bg-primary-700 text-primary-700',
  'secondary': 'border-secondary-400 hover:bg-secondary-400 active:bg-secondary-700 text-secondary-700',
  'success': 'border-success-400 hover:bg-success-400 active:bg-success-700 text-success-700',
  'warn': 'border-warn-400 hover:bg-warn-400 active:bg-warn-700 text-warn-700',
  'danger': 'border-danger-400 hover:bg-danger-400 active:bg-danger-700 text-danger-700'
}

const Button: React.FC<Props> = ({
  onClick,
  disabled,
  className,
  color = 'neutral',
  type = 'button',
  children
}) => {
  const c = (colors[color] || colors['neutral']) + " rounded bg-white border text-black active:text-white py-2 px-4 disabled:bg-gray-400 disabled:text-gray-700 disabled:border-gray-700 disabled:cursor-not-allowed " + (className || '')
  return <button type={type} className={c} disabled={disabled} onClick={onClick}>{children}</button>
}

export default Button;